export default "__VITE_ASSET__Dbk6EGWH__"